module.exports = __webpack_public_path__ + "static/img/chatBot.1d15de84.svg";